// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);

  const variant = evt.detail && evt.detail.variant ? evt.detail.variant : null;
  if (!variant) return;

  const productTitleVariant = document.getElementById("product__title__variant");
  if (productTitleVariant) {
    productTitleVariant.innerHTML = " - " + variant.title;
  }

  const reviewsShort = document.getElementById("reviews-short");
  if (reviewsShort) {
    reviewsShort.setAttribute("data-sku", variant.sku);
  }

  const reviewsFull = document.getElementById("reviews-full");
  if (reviewsFull) {
    reviewsFull.setAttribute("data-sku", variant.sku);
  }

  const productPrice = document.getElementById("product-price");
  if (productPrice) {
    productPrice.setAttribute("data-lion-price-for-product-id", variant.id);
  }

  const productPointsTotal = document.getElementById("product-points-total");
  if (productPointsTotal) {
    productPointsTotal.setAttribute("data-lion-points-for-product-id", variant.id);
  }

  if (window.loyaltylion && window.loyaltylion.ui) {
    window.loyaltylion.ui.refresh();
  }

  if (window.Klarna && window.Klarna.OnsiteMessaging) {
    window.Klarna.OnsiteMessaging.refresh();
  }

  if (window.Trustpilot && reviewsShort) {
    window.Trustpilot.loadFromElement(reviewsShort, true);
  }

  if (window.Trustpilot && reviewsFull) {
    setTimeout(function () {
      window.Trustpilot.loadFromElement(reviewsFull, true);
    }, 400);
  }

  const clearPayPrice = variant.price / 100;
  const clearPayTag = document.getElementsByTagName("square-placement")[0];

  if (clearPayTag) {
    clearPayTag.setAttribute("data-amount", clearPayPrice);
  }
});

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");

  const trustbox = document.getElementById("reviews-short");

  if (window.Trustpilot && trustbox) {
    window.Trustpilot.loadFromElement(trustbox);
  }

  if (window.loyaltylion && window.loyaltylion.ui) {
    window.loyaltylion.ui.refresh();
  }
});

// Refresh LoyaltyLion when Globo dynamically inserts product results
(function () {
  "use strict";

  var LOYALTY_SELECTOR =
    "[data-lion-price-for-product-id], " +
    "[data-lion-points-for-product-id]";

  var refreshTimer = null;
  var retryTimer = null;
  var retryCount = 0;
  var MAX_RETRIES = 10;

  function runLoyaltyLionRefresh() {
    if (
      window.loyaltylion &&
      window.loyaltylion.ui &&
      typeof window.loyaltylion.ui.refresh === "function"
    ) {
      window.loyaltylion.ui.refresh();
      retryCount = 0;
      return true;
    }

    return false;
  }

  function scheduleLoyaltyLionRefresh() {
    window.clearTimeout(refreshTimer);
    window.clearTimeout(retryTimer);

    refreshTimer = window.setTimeout(function attemptRefresh() {
      if (runLoyaltyLionRefresh()) {
        return;
      }

      if (retryCount < MAX_RETRIES) {
        retryCount += 1;
        retryTimer = window.setTimeout(attemptRefresh, 250);
      } else {
        retryCount = 0;
      }
    }, 100);
  }

  function containsLoyaltyMarkup(node) {
    if (!(node instanceof Element)) {
      return false;
    }

    return (
      node.matches(LOYALTY_SELECTOR) ||
      Boolean(node.querySelector(LOYALTY_SELECTOR))
    );
  }

  function initialiseGloboLoyaltyLion() {
    if (!document.body) {
      return;
    }

    if (document.querySelector(LOYALTY_SELECTOR)) {
      scheduleLoyaltyLionRefresh();
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (containsLoyaltyMarkup(node)) {
            shouldRefresh = true;
          }
        });
      });

      if (shouldRefresh) {
        scheduleLoyaltyLionRefresh();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseGloboLoyaltyLion
    );
  } else {
    initialiseGloboLoyaltyLion();
  }
})();

// Collection Page video pause and play
(function () {
  "use strict";

  var SELECTOR = "video[data-autoplay-product-card]";
  var VISIBILITY_THRESHOLD = 0.25;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function ensureInlineAutoplayAttrs(video) {
    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.playsInline = true;

    if (!video.getAttribute("preload")) {
      video.setAttribute("preload", "none");
    }
  }

  function safePlay(video) {
    try {
      var p = video.play();
      if (p && typeof p.catch === "function") {
        p.catch(function () {});
      }
    } catch (e) {}
  }

  function safePause(video) {
    try {
      video.pause();
    } catch (e) {}
  }

  function initAutoplayForProductCardVideos(root) {
    if (prefersReducedMotion()) return;

    var scope = root || document;
    var videos = scope.querySelectorAll(SELECTOR);
    if (!videos || !videos.length) return;

    if (!window.__v6ProductCardVideoIO) {
      window.__v6ProductCardVideoIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            var isVisible =
              entry.isIntersecting &&
              entry.intersectionRatio >= VISIBILITY_THRESHOLD;

            if (document.hidden) {
              safePause(video);
              return;
            }

            if (isVisible) {
              safePlay(video);
            } else {
              safePause(video);
            }
          });
        },
        { threshold: [0, VISIBILITY_THRESHOLD, 0.5, 0.75, 1] }
      );
    }

    var io = window.__v6ProductCardVideoIO;

    videos.forEach(function (video) {
      if (video.__v6AutoplayBound) return;
      video.__v6AutoplayBound = true;

      ensureInlineAutoplayAttrs(video);

      io.observe(video);
    });
  }

  function bindVisibilityPause() {
    if (window.__v6ProductCardVideoVisibilityBound) return;
    window.__v6ProductCardVideoVisibilityBound = true;

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) return;

      var videos = document.querySelectorAll(SELECTOR);
      videos.forEach(function (video) {
        safePause(video);
      });
    });
  }

  function boot() {
    bindVisibilityPause();
    initAutoplayForProductCardVideos(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    bindVisibilityPause();
    initAutoplayForProductCardVideos(evt.target);
  });

  document.addEventListener("quickview:loaded", function () {
    bindVisibilityPause();
    initAutoplayForProductCardVideos(document);
  });

  document.addEventListener("v6:product-card-video-added", function (evt) {
    bindVisibilityPause();

    if (evt.detail && evt.detail.video) {
      initAutoplayForProductCardVideos(
        evt.detail.video.parentElement
      );
    }
  });

})();


// Refresh free shipping bar HTML after cart updates
document.addEventListener("cart:updated", function () {
  fetch(window.location.pathname + "?section_id=main-cart")
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newBarWrap = doc.querySelector("#free-shipping-bar-wrap");
      const currentBarWrap = document.querySelector("#free-shipping-bar-wrap");

      if (newBarWrap && currentBarWrap) {
        currentBarWrap.replaceWith(newBarWrap);

        document.dispatchEvent(
          new CustomEvent("v6:free-shipping-bar-replaced")
        );
      }
    })
    .catch(function (error) {
      console.warn("Free shipping bar refresh failed:", error);
    });
});


// Update free shipping bar values after cart updates
document.addEventListener("cart:updated", function (evt) {
  setTimeout(function () {
    if (evt.detail && evt.detail.cart) {
      updateFreeShippingBar(evt.detail.cart);
    }
  }, 50);
});

function updateFreeShippingBar(cart) {
  const bar = document.querySelector(".free-shipping-bar");
  if (!bar || !cart) return;

  const message = bar.querySelector(".free-shipping-bar__message");
  const progressBar = bar.querySelector(".free-shipping-bar__bar-progress");

  if (!message || !progressBar) return;

  let threshold = parseInt(bar.dataset.threshold, 10);
  const successMessage = bar.dataset.freeShippingSuccessMessage || "";
  const pendingMessage = bar.dataset.freeShippingPendingMessage || "";
  const cartTotal = parseInt(cart.total_price, 10);

  if (isNaN(threshold) || isNaN(cartTotal)) return;

  threshold = Math.round(
    threshold *
      ((window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.rate) ||
        1)
  );

  const thresholdInCents = threshold * 100;

  if (cartTotal >= thresholdInCents) {
    bar.classList.add("free-shipping-bar--success");
    message.innerText = successMessage;
    progressBar.style.setProperty("--progress-width", "100%");
  } else {
    bar.classList.remove("free-shipping-bar--success");

    const remainder = thresholdInCents - cartTotal;
    const formattedRemainder = (remainder / 100).toFixed(2);

    message.innerHTML = pendingMessage.replace(
      "{{ remaining_amount }}",
      '<span class="fs-body-bold">' + formattedRemainder + "</span>"
    );

    const progress = (cartTotal / thresholdInCents) * 100;
    progressBar.style.setProperty("--progress-width", progress + "%");
  }

  bar.classList.add("free-shipping-bar--loaded");
}


// Move free shipping bar on mobile cart page
(function () {
  const MOBILE_BREAKPOINT = 959;

  let originalParent = null;
  let originalNextSibling = null;

  function moveFreeShippingBarForMobile() {
    const freeShippingBarWrap = document.querySelector("#free-shipping-bar-wrap");
    const cartFormItems = document.querySelector(".cart__form-items");

    if (!freeShippingBarWrap || !cartFormItems) return;

    if (!originalParent || !document.body.contains(originalParent)) {
      originalParent = freeShippingBarWrap.parentNode;
      originalNextSibling = freeShippingBarWrap.nextSibling;
    }

    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      if (cartFormItems.firstElementChild !== freeShippingBarWrap) {
        cartFormItems.prepend(freeShippingBarWrap);
      }
    } else if (originalParent && document.body.contains(originalParent)) {
      if (originalNextSibling && document.body.contains(originalNextSibling)) {
        originalParent.insertBefore(freeShippingBarWrap, originalNextSibling);
      } else {
        originalParent.appendChild(freeShippingBarWrap);
      }
    }
  }

  function runMove() {
    window.requestAnimationFrame(moveFreeShippingBarForMobile);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runMove);
  } else {
    runMove();
  }

  window.addEventListener("resize", runMove);

  document.addEventListener("cart:updated", function () {
    setTimeout(runMove, 100);
  });

  document.addEventListener("v6:free-shipping-bar-replaced", runMove);

  document.addEventListener("shopify:section:load", runMove);
})();